import { GlobalMenu } from '@components';
import { NavigationContext } from '@layout/navigation/navigation';
import { InviteUserRole } from '@models/Invite.model';
import { MenuButton } from '@pages/Products/Products.styles';
import { EQUIPMENTS_PICKER_SEND_TYPE } from '@store/machines/equipmentsPicker';
import { useContext } from 'react';

interface IProductsPageMenu {
  send: EQUIPMENTS_PICKER_SEND_TYPE;
  exportViewToCsv: () => void;
  exportAllToCsv: () => void;
  className?: string;
}

const ProductsPageMenu = ({
  send,
  exportViewToCsv,
  exportAllToCsv,
  ...rest
}: IProductsPageMenu) => {
  const { role } = useContext(NavigationContext);

  return (
    <MenuButton {...rest}>
      <GlobalMenu
        align="end"
        title="Additional Actions"
        width="40px"
        height="40px"
        hoverColor="transparent"
        itemList={[
          {
            disabled: [InviteUserRole.VIEWER].includes(role),
            toolTipText: [InviteUserRole.VIEWER].includes(role)
              ? 'Viewers are not allowed to edit inventory.'
              : 'Select multiple assets to launch the mass edit panel to make group edits on multiple assets at the same time. You can edit fields, tags, statuses or assignees through this panel.',
            toolTipId: 'massEditTooltip',
            label: 'Mass edit',
            iconName: 'annotation',
            onClick: () => {
              send({ type: 'MASS-EDIT' });
            },
          },
          {
            disabled: [InviteUserRole.VIEWER].includes(role),
            toolTipText: [InviteUserRole.VIEWER].includes(role)
              ? 'Viewers are not allowed to export all inventory to .CSV'
              : 'This will generate a .CSV file that exports every asset you have in BEAM with all the related field data, tags, statuses and assignees. Once the file is generated, it will automatically download to your device.',
            toolTipId: 'exportAllTooltip',
            label: 'Export all to .CSV',
            iconName: 'document-share',
            onClick: exportAllToCsv,
          },
          {
            disabled: [InviteUserRole.VIEWER].includes(role),
            toolTipText: [InviteUserRole.VIEWER].includes(role)
              ? 'Viewers are not allowed to export current view of inventory to .CSV'
              : 'This will generate a .CSV file that will only export the list currently shown on the inventory page, taking into account any filters or search terms you have entered. This will also only export the fields currently displayed in this view (i.e. header items). Once the file is generated, it will automatically download to your device.',
            toolTipId: 'exportViewTooltip',
            label: 'Export current view to .CSV',
            iconName: 'document-share',
            onClick: exportViewToCsv,
          },
        ]}
      />
    </MenuButton>
  );
};
export default ProductsPageMenu;
